
import { defineComponent } from 'vue';

// Components
import DotsLoader from '../dots-loader/dots-loader.vue';
// Helpers
import { isBookingPortalFlow } from '@white-label-helper/booking-portal-flow';


export default defineComponent({
  components: {
    DotsLoader,
  },
  props: {
    title: {
      type: String,
      default: '',
    }
  },
  computed:{
    /**
     * Returns the payment form details title
     */
    paymentDetailsTitle() {
      return this.isBookingPortalFlowEnabled ? this.$t('payment.customerDetails') : this.title || this.$t('payment.yourDetails')
    },
    isBookingPortalFlowEnabled(): boolean {
      return isBookingPortalFlow();
    },
  }
});
